<div class="flex flex-col">
  <!-- Chart Header Row -->
  <div class="flex flex-row">
    <div class="flex flex-wrap tb:flex-nowrap tb:flex-row justify-between items-center basis-11/12">
      <h2 class="dialog-title" [appDynamicStyles]="{ 'font-size': { zoomout: '16px', zoomin: '14.5px' } }">
        Total Carbon Emissions by Month
      </h2>
      <span class="dialog-title" [appDynamicStyles]="{ 'font-size': { zoomout: '16px', zoomin: '14.5px' } }">
        Across Selected Months
      </span>
    </div>
    <div class="flex items-center absolute right-0 basis-1/12">
      <button mat-flat-button mat-dialog-title [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Chart Body -->
  <mat-dialog-content class="overflow-y-hidden pb-0">
  <div *ngIf="barChartData.length > 0" class="comparisionDialog w-full px-4 flex justify-center">
    <div class="w-[600px] h-[500px]">
      <ngx-charts-bar-vertical
        [results]="barChartData"
        [xAxis]="true"
        [yAxis]="true"
        [legend]="true"
        [showXAxisLabel]="true"
        [showYAxisLabel]="true"
        [xAxisLabel]="'Month'"
        [yAxisLabel]="'Carbon Emissions (kg CO₂)'"
        [scheme]="colorScheme"
        [animations]="true"
        [barPadding]="180"
        [groupPadding]="40"
        [roundEdges]="true"
        class="w-full h-full"
      >
      </ngx-charts-bar-vertical>
    </div>
  </div>


    <!-- No Data Message -->
    <div
      *ngIf="barChartData.length === 0"
      class="message-box warning flex flex-row items-center"
    >
      No data to display for selected months.
    </div>
  </mat-dialog-content>
</div>
